<div class="dialog-container" [@openState]="state">
  <div class="dialog">
    <div class="heading">
      <h2>Télécharger sur...</h2>
      <t-icon name="close" class="close" (click)="close()" title="Fermer"></t-icon>
    </div>
    <div class="content">

      <a class="option" [href]="localUrl">
        <t-icon name="file_download"></t-icon>
        <span class="text">Ma machine</span>
      </a>

      <a class="option" (click)="downloadToDropbox()">
        <t-icon name="dropbox"></t-icon>
        <span class="text">Dropbox</span>
      </a>
      
    </div>
  </div>
</div>